// Talking Family Tree — feature palette, sampled from the provided
// talking-family-tree-desktop.png / -mobile.png designs.

export const FT_COLORS = {
  primary: '#9B59B6',
  primaryDark: '#7C459A',
  // Light lavender used for the "Create an invitation" button, selected states, highlights.
  surface: '#F4EEFA',
  surfaceBorder: '#E7DBF2',
  rowBorder: '#ECECEF',
  dashedBorder: '#D9D2E3',
  text: '#16161D',
  muted: '#0E0E0E',
  successBg: '#DAFDE1',
  successText: '#0E7C42',
};

// Content column width from the design annotation ("all major app fields are 680px wide").
export const FT_CONTENT_WIDTH = 680;
